/**
 * TEMPORARY DEMO DATA FOR UI DEMONSTRATION
 * This file contains hardcoded demo data matching API response structures.
 * Remove this file and related demo mode checks when real API is ready.
 */

// TODO: Replace demoSequences with backend API once sequence endpoints are available
export const demoSequences = [
  {
    id: 'seq-1',
    name: 'Sequence 1',
    createdBy: 'Demo User',
    createdDate: '2024-01-10',
    status: 'Generated',
    pipes: [
      { id: 'pipe-001', pipeNumber: 'PIPE-001' },
      { id: 'pipe-002', pipeNumber: 'PIPE-002' },
      { id: 'pipe-003', pipeNumber: 'PIPE-003' },
      { id: 'pipe-004', pipeNumber: 'PIPE-004' },
    ],
  },
  {
    id: 'seq-2',
    name: 'Sequence 2',
    createdBy: 'Demo User',
    createdDate: '2024-01-11',
    status: 'Generated',
    pipes: [
      { id: 'pipe-005', pipeNumber: 'PIPE-005' },
      { id: 'pipe-006', pipeNumber: 'PIPE-006' },
      { id: 'pipe-007', pipeNumber: 'PIPE-007' },
      { id: 'pipe-008', pipeNumber: 'PIPE-008' },
    ],
  },
];

// Demo sequence configuration data
export const DEMO_SPREAD_CONFIGURATION = {
  status: 200,
  message: 'Fetched successfully',
  data: {
    spreadList: [
      {
        id: 1,
        projectNumber: '001',
        spreadName: 'Sequence 1',
        targetNumberOfPipes: 50,
        sortOrder: 1,
        sequenceGenerationStatus: 'Completed',
        sequenceApprovalStatus: 'Pending',
        // subSpreads: [
        //   {
        //     id: 1,
        //     spreadId: 1,
        //     subSpreadName: 'SubSpread 1A',
        //     sortOrder: 1,
        //     sequenceGenerationStatus: 'Completed',
        //     sequenceApprovalStatus: 'Approved',
        //   },
        //   {
        //     id: 2,
        //     spreadId: 1,
        //     subSpreadName: 'SubSpread 1B',
        //     sortOrder: 2,
        //     sequenceGenerationStatus: 'Pending',
        //     sequenceApprovalStatus: 'Pending',
        //   },
        // ],
      },
      {
        id: 2,
        projectNumber: '001',
        spreadName: 'Sequence 2',
        targetNumberOfPipes: 30,
        sortOrder: 2,
        sequenceGenerationStatus: 'InProgress',
        sequenceApprovalStatus: 'Pending',
        // subSpreads: [
        //   {
        //     id: 3,
        //     spreadId: 2,
        //     subSpreadName: 'SubSpread 2A',
        //     sortOrder: 1,
        //     sequenceGenerationStatus: 'Completed',
        //     sequenceApprovalStatus: 'Pending',
        //   },
        // ],
      },
    ],
  },
};

// Demo Pipe Counts Data
export const DEMO_PIPE_COUNTS = {
  status: 200,
  message: 'Project created successfully',
  data: {
    projectPipeCount: 2,
    usedPipeCount: 24,
    totalPipeCount: 26,
    spreadAvailablePipeCount: 2,
    subSpreadAvailablePipeCount: 2,
  },
};

// Demo Sequence List Data
export const DEMO_SEQUENCE_LIST = {
  status: 200,
  message: 'Fetched successfully',
  data: {
    recordList: [
      {
        id: 1,
        projectNumber: '001',
        spread: 1,
        subSpread: null,
        pipeStart: 'PIPE001',
        pipeEnd: 'PIPE002',
        length: 12.5,
        sequenceNumber: 1,
        createdAt: '2024-09-04T08:52:03.000Z',
        updatedAt: '2024-09-04T08:52:03.000Z',
      },
      {
        id: 2,
        projectNumber: '001',
        spread: 1,
        subSpread: null,
        pipeStart: 'PIPE002',
        pipeEnd: 'PIPE003',
        length: 11.8,
        sequenceNumber: 2,
        createdAt: '2024-09-04T08:52:03.000Z',
        updatedAt: '2024-09-04T08:52:03.000Z',
      },
      {
        id: 3,
        projectNumber: '001',
        spread: 1,
        subSpread: null,
        pipeStart: 'PIPE003',
        pipeEnd: 'PIPE004',
        length: 13.2,
        sequenceNumber: 3,
        createdAt: '2024-09-04T08:52:03.000Z',
        updatedAt: '2024-09-04T08:52:03.000Z',
      },
      {
        id: 4,
        projectNumber: '001',
        spread: 1,
        subSpread: 1,
        pipeStart: 'PIPE004',
        pipeEnd: 'PIPE005',
        length: 10.9,
        sequenceNumber: 1,
        createdAt: '2024-09-04T08:52:03.000Z',
        updatedAt: '2024-09-04T08:52:03.000Z',
      },
      {
        id: 5,
        projectNumber: '001',
        spread: 1,
        subSpread: 1,
        pipeStart: 'PIPE005',
        pipeEnd: 'PIPE006',
        length: 12.1,
        sequenceNumber: 2,
        createdAt: '2024-09-04T08:52:03.000Z',
        updatedAt: '2024-09-04T08:52:03.000Z',
      },
    ],
    count: 50,
  },
};

// Demo Pipe Scan Data (Project Status)
export const DEMO_PIPE_SCAN_DATA = {
  status: 200,
  message: 'Fetched successfully',
  data: {
    pipeList: [
      { date: '2024-09-03', count: 1 },
      { date: '2024-09-04', count: 51 },
      { date: '2024-09-05', count: 35 },
      { date: '2024-09-06', count: 42 },
      { date: '2024-09-07', count: 28 },
    ],
  },
};

// Demo Pipe Statistics Data
export const DEMO_PIPE_STATISTICS = {
  status: 200,
  message: 'Fetched successfully',
  data: {
    pipeStats: {
      id: 1,
      projectNumber: '001',
      avgIDAvg: 130.21,
      avgIDMax: 132.344,
      avgIDMin: 129.676,
      maxIDAvg: 130.617,
      maxIDMax: 132.685,
      maxIDMin: 130.014,
      minIDAvg: 129.824,
      minIDMax: 132.089,
      minIDMin: 129.251,
      ooRAvg: 0.792906,
      ooRMax: 1.24835,
      ooRIDMin: 0.543299,
      avgODAvg: 0,
      avgODMax: 0,
      avgODMin: 0,
      maxODAvg: 0,
      maxODMax: 0,
      maxODMin: 0,
      minODAvg: 0,
      minODMax: 0,
      minODMin: 0,
      ooRODAvg: 0,
      ooRODMax: 0,
      ooRODMin: 0,
      createdAt: '2024-09-04T08:52:03.000Z',
      updatedAt: '2025-12-17T17:15:52.000Z',
    },
  },
};

// Demo Pipe Status Data (for Pipe Details tab)
export const DEMO_PIPE_STATUS_DATA = {
  status: 200,
  message: 'Fetched successfully',
  data: [
    {
      pipeID: 'PIPE001',
      projectNumber: '001',
      spread: 'Sequence 1',
      subSpread: 'Sub-sequence 1A',
      status: 'Available',
      endA: true,
      endB: false,
    },
    {
      pipeID: 'PIPE002',
      projectNumber: '001',
      spread: 'Sequence 1',
      subSpread: 'Sub-sequence 1A',
      status: 'Used',
      endA: true,
      endB: true,
    },
    {
      pipeID: 'PIPE003',
      projectNumber: '001',
      spread: 'Sequence 1',
      subSpread: 'Sub-sequence 1B',
      status: 'Available',
      endA: false,
      endB: false,
    },
    {
      pipeID: 'PIPE004',
      projectNumber: '001',
      spread: 'Sequence 2',
      subSpread: 'Sub-sequence 2A',
      status: 'Assigned',
      endA: true,
      endB: false,
    },
    {
      pipeID: 'PIPE005',
      projectNumber: '001',
      spread: 'Any',
      subSpread: 'Any',
      status: 'Unassigned',
      endA: false,
      endB: false,
    },
  ],
};
